import { NAVIGATION_PATHS } from "./navigation";

// Default protected route to navigate to after login
// TODO: Update this to the dashboard page once available
export const DEFAULT_PROTECTED_ROUTE = NAVIGATION_PATHS.REPORT_STUDIO;

// How often to refresh the token (in minutes)
// More frequent checks to catch expiration immediately
export const TOKEN_REFRESH_INTERVAL = 5;

// Token age threshold before considering it stale (in minutes).
// Short lifetime reduces impact of token theft; MSAL refresh supplies new tokens.
export const TOKEN_STALE_THRESHOLD = 15;

// App-issued (email-code) session JWTs. Must match the backend EXTERNAL_JWT_ISSUER.
export const APP_JWT_ISSUER = "medirect-copilot";
// External users have no MSAL silent-refresh, so their token is persisted here
// (sessionStorage: survives page refresh, cleared when the tab closes) to honour
// the ~8h session. MSAL tokens are NOT persisted.
export const APP_SESSION_STORAGE_KEY = "app_session_token";

// Authentication error messages
export const AUTH_ERRORS = {
  LOGIN_FAILED: "Login failed. Please try again later.",
  SESSION_EXPIRED: "Your session has expired. Please sign in again.",
  TOKEN_REFRESH_FAILED: "Unable to refresh authentication. Please sign in again.",
};
